// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Nicholas-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Poppins-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Brand fonts. Both bundled by webpack (asset/resource) — see webpack.config.js. */
@font-face {
  font-family: 'Nicholas';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}
/* Real semibold for deliberate emphasis only. Kept under its own family name so
   the app's existing font-semibold/bold classes keep their current look. */
@font-face {
  font-family: 'Poppins Emphasis';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

:root {
  --snail: #5D4E2F;      /* Primary accent, active states */
  --sand: #EEE9E1;       /* Light backgrounds, cards */
  --pewter: #4E574E;     /* Secondary elements, borders */
  --dew: #DAD6CE;        /* Hover states, subtle highlights */
  --forest: #263328;     /* Dark UI elements, sidebar */
  --charcoal: #181818;   /* Primary dark background */
  --stone: #3a3a3a;      /* Dark border color */
  --fern: #04963a;       /* Success, interactive green */
  --midnight: #0f0f0f;   /* Deepest dark, dropdowns */
  --black: #000000;      /* Pure black backgrounds */
  --error-red: #ef4444;  /* Error, destructive actions */
  --rust: #9a3412;       /* Warning, attention states */

  /* Brand typography */
  --font-heading: 'Nicholas', 'Helvetica Neue', Arial, sans-serif;
  --font-body: 'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif;
  --font-emphasis: 'Poppins Emphasis', 'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif;
}

.ls-emphasis {
  font-family: var(--font-emphasis);
  font-weight: 600;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .\\!container {
    max-width: 640px !important;
  }
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .\\!container {
    max-width: 768px !important;
  }
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .\\!container {
    max-width: 1024px !important;
  }
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .\\!container {
    max-width: 1280px !important;
  }
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .\\!container {
    max-width: 1536px !important;
  }
  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-top-3 {
  top: -0.75rem;
}
.-top-7 {
  top: -1.75rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-32 {
  bottom: 8rem;
}
.bottom-36 {
  bottom: 9rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-7 {
  bottom: 1.75rem;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-full {
  top: 100%;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[110\\] {
  z-index: 110;
}
.z-\\[55\\] {
  z-index: 55;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[65\\] {
  z-index: 65;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[75\\] {
  z-index: 75;
}
.z-\\[80\\] {
  z-index: 80;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.m-2 {
  margin: 0.5rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-ml-5 {
  margin-left: -1.25rem;
}
.-mr-0\\.5 {
  margin-right: -0.125rem;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mt-0\\.5 {
  margin-top: -0.125rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.mt-\\[3px\\] {
  margin-top: 3px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.list-item {
  display: list-item;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[8px\\] {
  height: 8px;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[180px\\] {
  max-height: 180px;
}
.max-h-\\[280px\\] {
  max-height: 280px;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[calc\\(80vh-80px\\)\\] {
  max-height: calc(80vh - 80px);
}
.max-h-full {
  max-height: 100%;
}
.max-h-none {
  max-height: none;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[140px\\] {
  min-height: 140px;
}
.min-h-\\[32px\\] {
  min-height: 32px;
}
.min-h-\\[360px\\] {
  min-height: 360px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[18\\%\\] {
  width: 18%;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[46\\%\\] {
  width: 46%;
}
.w-\\[min\\(22rem\\2c calc\\(100vw-2rem\\)\\)\\] {
  width: min(22rem,calc(100vw - 2rem));
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-44 {
  min-width: 11rem;
}
.min-w-48 {
  min-width: 12rem;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[22px\\] {
  min-width: 22px;
}
.min-w-\\[70px\\] {
  min-width: 70px;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.max-w-0 {
  max-width: 0px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[95vw\\] {
  max-width: 95vw;
}
.max-w-\\[calc\\(100vw-2rem\\)\\] {
  max-width: calc(100vw - 2rem);
}
.max-w-\\[min\\(90vw\\2c 30rem\\)\\] {
  max-width: min(90vw,30rem);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-\\[2\\] {
  flex: 2;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-crosshair {
  cursor: crosshair;
}
.cursor-ew-resize {
  cursor: ew-resize;
}
.cursor-grab {
  cursor: grab;
}
.cursor-move {
  cursor: move;
}
.cursor-nesw-resize {
  cursor: nesw-resize;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-ns-resize {
  cursor: ns-resize;
}
.cursor-nwse-resize {
  cursor: nwse-resize;
}
.cursor-pointer {
  cursor: pointer;
}
.touch-none {
  touch-action: none;
}
.touch-manipulation {
  touch-action: manipulation;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.columns-1 {
  -moz-columns: 1;
       columns: 1;
}
.break-inside-avoid {
  -moz-column-break-inside: avoid;
       break-inside: avoid;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-center {
  justify-items: center;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-10 {
  -moz-column-gap: 2.5rem;
       column-gap: 2.5rem;
}
.gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-5 {
  -moz-column-gap: 1.25rem;
       column-gap: 1.25rem;
}
.gap-x-7 {
  -moz-column-gap: 1.75rem;
       column-gap: 1.75rem;
}
.gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-bl {
  border-bottom-left-radius: 0.25rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-\\[color\\:var\\(--dew\\)\\] {
  border-color: var(--dew);
}
.border-\\[color\\:var\\(--forest\\)\\] {
  border-color: var(--forest);
}
.border-\\[var\\(--pewter\\)\\] {
  border-color: var(--pewter);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-t-blue-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[color\\:var\\(--dew\\)\\] {
  background-color: var(--dew);
}
.bg-\\[color\\:var\\(--sand\\)\\] {
  background-color: var(--sand);
}
.bg-\\[var\\(--charcoal\\)\\] {
  background-color: var(--charcoal);
}
.bg-\\[var\\(--forest\\)\\] {
  background-color: var(--forest);
}
.bg-\\[var\\(--pewter\\)\\] {
  background-color: var(--pewter);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/90 {
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800\\/50 {
  background-color: rgb(31 41 55 / 0.5);
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10 {
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-900\\/90 {
  background-color: rgb(127 29 29 / 0.9);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-16 {
  padding: 4rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10\\.5px\\] {
  font-size: 10.5px;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12\\.5px\\] {
  font-size: 12.5px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.not-italic {
  font-style: normal;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.12\\] {
  line-height: 1.12;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.13em\\] {
  letter-spacing: 0.13em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[color\\:var\\(--charcoal\\)\\] {
  color: var(--charcoal);
}
.text-\\[color\\:var\\(--forest\\)\\] {
  color: var(--forest);
}
.text-\\[var\\(--dew\\)\\] {
  color: var(--dew);
}
.text-\\[var\\(--sand\\)\\] {
  color: var(--sand);
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-red-200 {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.accent-\\[var\\(--sand\\)\\] {
  accent-color: var(--sand);
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.\\!ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-blue-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.ring-green-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* ── Canonical modal surfaces ─────────────────────────────────────────────
   Single source of truth for every dialog on the platform, so they all share
   one frame. The card backing + stroke are both charcoal: the backing means
   the rounded corners can never leak a lighter colour (the old sand-bleed
   bug), and the charcoal stroke reads as a clean edge distinct from any of the
   forest/sand/pewter section bands. Edge separation from the scrim comes from a
   soft, layered shadow rather than a hard border. Header/body/footer bands
   paint their own backgrounds on top. */
.ls-modal-backdrop {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.ls-modal-card {
  background-color: var(--charcoal);
  border: 1px solid var(--charcoal);
  border-radius: 14px;
  overflow: hidden;
  box-shadow:
    0 32px 80px -24px rgba(0, 0, 0, 0.75),
    0 12px 34px -14px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(0, 0, 0, 0.4);
}

/* Header/footer bands lose their own outer rounding since .ls-modal-card clips;
   this just keeps their top/bottom corners flush inside the frame. */
.ls-modal-band-top    { border-top-left-radius: 13px; border-top-right-radius: 13px; }
.ls-modal-band-bottom { border-bottom-left-radius: 13px; border-bottom-right-radius: 13px; }

/* Gentle entrance for modal cards — a whisper of lift, nothing bouncy. */
@keyframes lsModalIn {
  from { opacity: 0; transform: translateY(8px) scale(0.985); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
.ls-modal-card-animate { animation: lsModalIn 0.22s cubic-bezier(0.16, 1, 0.3, 1); }

/* Layer-row slider extension (SliderUnderBar) — quick settle as the row expands. */
@keyframes lsUnderbarIn {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}
.ls-underbar { animation: lsUnderbarIn 0.15s ease-out; }

@media (prefers-reduced-motion: reduce) {
  .ls-modal-card-animate { animation: none; }
  .ls-underbar { animation: none; }
}

/* Smooth fade-in animation for waitlist modal */
@keyframes fadeInSlide {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Cesium specific styles */
html, body, #root {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: var(--font-body);
}

/* Headings use the brand display face. */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-heading);
}

/* Tailwind utility for opting in explicitly when the element isn't a real heading. */
.font-heading { font-family: var(--font-heading) !important; }
.font-body    { font-family: var(--font-body) !important; }

/* Print styles for Report Modal */
@media print {
  html, body {
    background: #ffffff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
    height: auto !important;
    overflow: visible !important;
  }
  /* Hide everything by default */
  body * { visibility: hidden !important; }
  /* Show only the report modal content and its children */
  #report-modal-content, #report-modal-content * {
    visibility: visible !important;
  }
  /* Position the modal content at the top-left and expand for page */
  #report-modal-content {
    position: static !important;
    inset: auto !important;
    box-shadow: none !important;
    border: 0 !important;
    background: #ffffff !important;
    max-height: none !important;
    overflow: visible !important;
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  /* Prevent awkward page breaks in cards/grids */
  #report-modal-content .border-2,
  #report-modal-content .p-4,
  #report-modal-content .rounded-lg,
  #report-modal-content .grid,
  #report-modal-content .h-64 {
    -moz-column-break-inside: avoid !important;
         break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  #report-modal-content svg { max-width: 100% !important; height: auto !important; }
  /* Remove global layout constraints */
  #root { height: auto !important; overflow: visible !important; }
}

/* When we explicitly request print via the button, relax global overflow too */
body.force-print {
  overflow: visible !important;
}

/* Ensure Cesium container takes full space */
#cesiumContainer {
  width: 100% !important;
  height: 100% !important;
  position: relative !important;
}

/* Ensure Cesium widget takes full space */
.cesium-widget,
.cesium-widget canvas {
  width: 100% !important;
  height: 100% !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
}

/* Basemap attribution. Cesium's own credit display stays in charge of what is
   shown (ion and Google logos on screen, per-view copyright behind the "Data
   attribution" link) because the ion and Google terms both require it; this
   only gives it the house look. Sits under the bottom-left pills (bottom-7). */
.cesium-viewer-bottom {
  z-index: 2;
  padding: 0 0 4px 8px;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
}

.cesium-viewer .cesium-widget-credits {
  font-family: var(--font-body);
  font-size: 10px;
  color: #fff;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.9), 0 1px 2px rgba(0, 0, 0, 0.7);
}

.cesium-credit-logoContainer,
.cesium-credit-textContainer,
.cesium-credit-expand-link {
  pointer-events: auto;
  vertical-align: middle;
}

.cesium-credit-logoContainer {
  margin-right: 14px;
}

.cesium-viewer .cesium-credit-textContainer .cesium-credit-wrapper:first-of-type {
  padding-left: 0;
}

.cesium-credit-textContainer .cesium-credit-wrapper {
  margin-right: 10px;
}

.cesium-viewer .cesium-credit-delimiter {
  padding: 0 4px 0 0;
}

.cesium-credit-logoContainer img,
.cesium-credit-textContainer img {
  height: 18px;
  width: auto;
  vertical-align: middle !important;
}

.cesium-viewer .cesium-credit-expand-link {
  padding-left: 4px;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
}

.cesium-viewer .cesium-credit-expand-link:hover {
  color: #fff;
  text-decoration: underline;
}

/* ion injects an "Upgrade for commercial use." link on Community-plan tokens,
   which only the dev token is. Hide it and whichever delimiter bounds it. */
.cesium-credit-wrapper:has(a[href*="cesium.com/pricing"]),
.cesium-credit-wrapper:has(a[href*="cesium.com/pricing"]) + .cesium-credit-delimiter,
.cesium-credit-delimiter:has(+ .cesium-credit-wrapper a[href*="cesium.com/pricing"]) {
  display: none !important;
}

.cesium-credit-lightbox-overlay {
  z-index: 200 !important;
  background-color: rgba(24, 24, 24, 0.6) !important;
}

.cesium-credit-lightbox {
  font-family: var(--font-body);
  background-color: var(--forest) !important;
  color: var(--sand) !important;
  border: 1px solid var(--pewter) !important;
  border-radius: 13px !important;
}

/* Cesium centres the box by an inline margin-top it measures once, before the
   copyright list has its final height, so a long Google list drifts low. Pin
   it to the true centre and let the list scroll instead. */
.cesium-credit-lightbox.cesium-credit-lightbox-expanded {
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  width: min(560px, calc(100% - 32px));
  max-width: none !important;
  max-height: min(70vh, calc(100% - 32px));
  display: flex;
  flex-direction: column;
}

.cesium-credit-lightbox-title {
  font-family: var(--font-emphasis);
  font-size: 14px;
  flex-shrink: 0;
}

.cesium-credit-lightbox > ul {
  font-size: 12px !important;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.cesium-credit-lightbox > ul > li a,
.cesium-credit-lightbox > ul > li a:visited {
  color: var(--sand) !important;
}

.cesium-credit-lightbox > ul > li a:hover,
.cesium-credit-lightbox-close:hover {
  color: var(--dew) !important;
}

.cesium-credit-lightbox > ul > li img {
  max-height: 24px;
  vertical-align: middle;
}

/* The same logos reproduced on the printed map window (PrintMapOverlay). */
.print-basemap-logo img {
  height: 18px;
  width: auto;
  vertical-align: middle !important;
}

.cesium-viewer-toolbar {
  display: none !important;
}

.cesium-viewer-animationContainer {
  display: none !important;
}

.cesium-viewer-timelineContainer {
  display: none !important;
}

.cesium-viewer-fullscreenContainer {
  display: none !important;
}

.cesium-viewer-vrContainer {
  display: none !important;
}

/* Info Panel Text Wrapping Styles */
.info-panel-content {
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
}

.info-panel-content p,
.info-panel-content div,
.info-panel-content span,
.info-panel-content td,
.info-panel-content th {
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
}

.info-panel-content pre {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
}

.info-panel-content table {
  table-layout: fixed !important;
  width: 100% !important;
}

/* Dot loader animation */
.dot-loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.dot-loader .dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background-color: var(--dew);
  opacity: 0.4;
  animation: dotFlashing 1.1s linear infinite;
}
.dot-loader .dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot-loader .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotFlashing {
  0% { opacity: 0.3; transform: translateY(0); }
  50% { opacity: 1; transform: translateY(-2px); }
  100% { opacity: 0.3; transform: translateY(0); }
}

/* Comment markdown content styles */
.comment-content {
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}
.comment-content p {
  margin: 0 0 0.5em 0;
}
.comment-content p:last-child {
  margin-bottom: 0;
}
.comment-content strong {
  font-weight: 600;
}
.comment-content em {
  font-style: italic;
}
.comment-content ul,
.comment-content ol {
  margin: 0.5em 0;
  padding-left: 1.5em;
}
.comment-content li {
  margin: 0.25em 0;
}
.comment-content code {
  background: rgba(255, 255, 255, 0.1);
  padding: 0.1em 0.3em;
  border-radius: 3px;
  font-family: monospace;
  font-size: 0.9em;
}
.comment-content a {
  color: var(--fern, #4ade80);
  text-decoration: underline;
}
.comment-content a:hover {
  opacity: 0.8;
}

/* Comment highlight pulse animation */
@keyframes highlight-pulse {
  0%, 100% { background-color: transparent; }
  50% { background-color: rgba(74, 222, 128, 0.2); }
}

.highlight-pulse {
  animation: highlight-pulse 0.5s ease-in-out 3;
}

/* Help tooltip */
.help-tooltip-trigger .help-tooltip {
  display: none;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 12px 14px;
  background-color: var(--charcoal);
  border: 1px solid var(--pewter);
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--dew);
  width: 280px;
  max-width: 90vw;
  z-index: 99999;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

.help-tooltip-trigger:hover .help-tooltip {
  display: block;
}

/* Thin dark scrollbars */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--stone) transparent;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--stone);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--pewter);
}

/* Demo unlock CTA — a pill whose stroke has a highlight travelling around it.
   Interior is painted with a padding-box layer, the rotating conic-gradient
   sits in the border-box layer and shows only through the transparent border.
   --demo-ring-color (tier color) and --demo-pill-bg (interior, swapped on
   hover) are set inline by the component. */
@property --demo-ring-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes demoRingSpin {
  to {
    --demo-ring-angle: 360deg;
  }
}

.demo-unlock-pill {
  border: 2px solid transparent;
  border-radius: 9999px;
  background:
    linear-gradient(var(--demo-pill-bg, #EEE9E1), var(--demo-pill-bg, #EEE9E1)) padding-box,
    conic-gradient(
      from var(--demo-ring-angle),
      var(--demo-ring-color, #dc2626) 0deg,
      #ffffff 28deg,
      var(--demo-ring-color, #dc2626) 70deg,
      var(--demo-ring-color, #dc2626) 360deg
    ) border-box;
  animation: demoRingSpin 2.8s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .demo-unlock-pill {
    animation: none;
  }
}

.focus-within\\:opacity-100:focus-within {
  opacity: 1;
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.03\\]:hover {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[color\\:var\\(--pewter\\)\\]:hover {
  border-color: var(--pewter);
}

.hover\\:bg-\\[\\#eee9e1\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 233 225 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[var\\(--dew\\)\\]:hover {
  background-color: var(--dew);
}

.hover\\:bg-\\[var\\(--pewter\\)\\]:hover {
  background-color: var(--pewter);
}

.hover\\:bg-\\[var\\(--sand\\)\\]:hover {
  background-color: var(--sand);
}

.hover\\:bg-black\\/10:hover {
  background-color: rgb(0 0 0 / 0.1);
}

.hover\\:bg-black\\/5:hover {
  background-color: rgb(0 0 0 / 0.05);
}

.hover\\:bg-blue-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700\\/40:hover {
  background-color: rgb(55 65 81 / 0.4);
}

.hover\\:bg-gray-700\\/60:hover {
  background-color: rgb(55 65 81 / 0.6);
}

.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}

.hover\\:bg-white\\/50:hover {
  background-color: rgb(255 255 255 / 0.5);
}

.hover\\:bg-opacity-10:hover {
  --tw-bg-opacity: 0.1;
}

.hover\\:bg-opacity-20:hover {
  --tw-bg-opacity: 0.2;
}

.hover\\:bg-opacity-80:hover {
  --tw-bg-opacity: 0.8;
}

.hover\\:bg-opacity-90:hover {
  --tw-bg-opacity: 0.9;
}

.hover\\:text-\\[\\#181818\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(24 24 24 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[var\\(--forest\\)\\]:hover {
  color: var(--forest);
}

.hover\\:text-\\[var\\(--sand\\)\\]:hover {
  color: var(--sand);
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-70:hover {
  opacity: 0.7;
}

.hover\\:opacity-75:hover {
  opacity: 0.75;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-current:focus {
  border-color: currentColor;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-opacity-40:focus {
  --tw-ring-opacity: 0.4;
}

.focus\\:ring-opacity-50:focus {
  --tw-ring-opacity: 0.5;
}

.focus-visible\\:opacity-100:focus-visible {
  opacity: 1;
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-\\[color\\:var\\(--forest\\)\\]:focus-visible {
  --tw-ring-color: var(--forest);
}

.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active {
  cursor: grabbing;
}

.active\\:ring-2:active {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.active\\:ring-blue-400:active {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}

.group:hover .group-hover\\:block {
  display: block;
}

.group:hover .group-hover\\:hidden {
  display: none;
}

.group\\/row:hover .group-hover\\/row\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

@media not all and (min-width: 768px) {
  .max-md\\:left-4 {
    left: 1rem;
  }
  .max-md\\:right-4 {
    right: 1rem;
  }
  .max-md\\:top-20 {
    top: 5rem;
  }
  .max-md\\:top-4 {
    top: 1rem;
  }
}

@media (min-width: 640px) {
  .sm\\:bottom-6 {
    bottom: 1.5rem;
  }
  .sm\\:left-1\\/2 {
    left: 50%;
  }
  .sm\\:right-auto {
    right: auto;
  }
  .sm\\:z-30 {
    z-index: 30;
  }
  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }
  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }
  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .sm\\:block {
    display: block;
  }
  .sm\\:inline {
    display: inline;
  }
  .sm\\:hidden {
    display: none;
  }
  .sm\\:h-2 {
    height: 0.5rem;
  }
  .sm\\:h-4 {
    height: 1rem;
  }
  .sm\\:h-6 {
    height: 1.5rem;
  }
  .sm\\:h-\\[24px\\] {
    height: 24px;
  }
  .sm\\:min-h-\\[80px\\] {
    min-height: 80px;
  }
  .sm\\:w-4 {
    width: 1rem;
  }
  .sm\\:w-6 {
    width: 1.5rem;
  }
  .sm\\:w-\\[32rem\\] {
    width: 32rem;
  }
  .sm\\:max-w-\\[300px\\] {
    max-width: 300px;
  }
  .sm\\:max-w-\\[95vw\\] {
    max-width: 95vw;
  }
  .sm\\:max-w-full {
    max-width: 100%;
  }
  .sm\\:max-w-lg {
    max-width: 32rem;
  }
  .sm\\:max-w-md {
    max-width: 28rem;
  }
  .sm\\:-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .sm\\:transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .sm\\:columns-2 {
    -moz-columns: 2;
         columns: 2;
  }
  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:flex-row {
    flex-direction: row;
  }
  .sm\\:gap-2 {
    gap: 0.5rem;
  }
  .sm\\:gap-3 {
    gap: 0.75rem;
  }
  .sm\\:gap-4 {
    gap: 1rem;
  }
  .sm\\:gap-6 {
    gap: 1.5rem;
  }
  .sm\\:space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
  }
  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }
  .sm\\:p-3 {
    padding: 0.75rem;
  }
  .sm\\:p-4 {
    padding: 1rem;
  }
  .sm\\:p-6 {
    padding: 1.5rem;
  }
  .sm\\:p-8 {
    padding: 2rem;
  }
  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .sm\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {
  .md\\:left-4 {
    left: 1rem;
  }
  .md\\:right-4 {
    right: 1rem;
  }
  .md\\:top-20 {
    top: 5rem;
  }
  .md\\:top-4 {
    top: 1rem;
  }
  .md\\:h-9 {
    height: 2.25rem;
  }
  .md\\:min-h-\\[160px\\] {
    min-height: 160px;
  }
  .md\\:w-9 {
    width: 2.25rem;
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:gap-2 {
    gap: 0.5rem;
  }
  .md\\:gap-4 {
    gap: 1rem;
  }
  .md\\:p-3 {
    padding: 0.75rem;
  }
  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .md\\:pb-3 {
    padding-bottom: 0.75rem;
  }
  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px) {
  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.05fr\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(0,1.05fr);
  }
  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(0,1fr);
  }
  .lg\\:gap-12 {
    gap: 3rem;
  }
  .lg\\:border-l {
    border-left-width: 1px;
  }
  .lg\\:pl-10 {
    padding-left: 2.5rem;
  }
  .lg\\:pl-12 {
    padding-left: 3rem;
  }
  .lg\\:pt-2 {
    padding-top: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;2EAC2E;AAC3E;EACE,+BAA+B;EAC/B,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,OAAO,kCAAkC;EACzD,eAAe,QAAQ,6BAA6B;EACpD,iBAAiB,MAAM,gCAAgC;EACvD,cAAc,SAAS,oCAAoC;EAC3D,iBAAiB,MAAM,8BAA8B;EACrD,mBAAmB,IAAI,4BAA4B;EACnD,gBAAgB,OAAO,sBAAsB;EAC7C,eAAe,QAAQ,+BAA+B;EACtD,mBAAmB,IAAI,4BAA4B;EACnD,gBAAgB,OAAO,2BAA2B;EAClD,oBAAoB,GAAG,+BAA+B;EACtD,eAAe,QAAQ,8BAA8B;;EAErD,qBAAqB;EACrB,+DAA+D;EAC/D,wEAAwE;EACxE,gGAAgG;AAClG;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd,kEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,eAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;;;;;wCAOwC;AACxC;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB;;;gCAG8B;AAChC;;AAEA;qEACqE;AACrE,wBAAwB,4BAA4B,EAAE,6BAA6B,EAAE;AACrF,wBAAwB,+BAA+B,EAAE,gCAAgC,EAAE;;AAE3F,yEAAyE;AACzE;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA,yBAAyB,wDAAwD,EAAE;;AAEnF,mFAAmF;AACnF;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,eAAe,sCAAsC,EAAE;;AAEvD;EACE,yBAAyB,eAAe,EAAE;EAC1C,eAAe,eAAe,EAAE;AAClC;;AAEA,gDAAgD;AAChD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;AAClC;;AAEA,qFAAqF;AACrF,gBAAgB,2CAA2C,EAAE;AAC7D,gBAAgB,wCAAwC,EAAE;;AAE1D,kCAAkC;AAClC;EACE;IACE,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;IACpC,8BAA8B;IAC9B,uBAAuB;IACvB,4BAA4B;EAC9B;EACA,+BAA+B;EAC/B,SAAS,6BAA6B,EAAE;EACxC,wDAAwD;EACxD;IACE,8BAA8B;EAChC;EACA,mEAAmE;EACnE;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;IACpB,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;EACvB;EACA,+CAA+C;EAC/C;;;;;IAKE,0CAA8B;SAA9B,8BAA8B;IAC9B,mCAAmC;EACrC;EACA,4BAA4B,0BAA0B,EAAE,uBAAuB,EAAE;EACjF,qCAAqC;EACrC,QAAQ,uBAAuB,EAAE,4BAA4B,EAAE;AACjE;;AAEA,+EAA+E;AAC/E;EACE,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,0CAA0C;AAC1C;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;+EAG+E;AAC/E;EACE,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,qEAAqE;AACvE;;AAEA;;;EAGE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;4EAC4E;AAC5E;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C;EAC1C,6BAA6B;EAC7B,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;;2DAE2D;AAC3D;EACE,6BAA6B;EAC7B,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,oCAAoC;EACpC,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,2EAA2E;AAC3E;EACE,YAAY;EACZ,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;;;;;EAKE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,KAAK,YAAY,EAAE,wBAAwB,EAAE;EAC7C,MAAM,UAAU,EAAE,2BAA2B,EAAE;EAC/C,OAAO,YAAY,EAAE,wBAAwB,EAAE;AACjD;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,WAAW,6BAA6B,EAAE;EAC1C,MAAM,yCAAyC,EAAE;AACnD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;4CAI4C;AAC5C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB;;;;;;;;gBAQc;EACd,4CAA4C;AAC9C;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AA/hBA;EAAA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,iBAgiBA;EAhiBA,iBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,kBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,oBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,oBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,+EAgiBA;EAhiBA,mGAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,6EAgiBA;EAhiBA,iGAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,8BAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,2GAgiBA;EAhiBA,yGAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,2GAgiBA;EAhiBA,yGAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,oBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,2GAgiBA;EAhiBA,yGAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,iBAgiBA;EAhiBA,iBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA,2GAgiBA;EAhiBA,yGAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA,oBAgiBA;EAhiBA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;AAgiBA;;AAhiBA;EAAA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;AAAA;;AAhiBA;EAAA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA,sBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA,eAgiBA;SAhiBA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA,uBAgiBA;IAhiBA,8DAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,uBAgiBA;IAhiBA,8DAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA,oBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,kBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,kBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,oBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,mBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,qBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,oBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,iBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,kBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,eAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,mBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,kBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA,kBAgiBA;IAhiBA;EAgiBA;AAAA;;AAhiBA;EAAA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA,oBAgiBA;IAhiBA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA,mBAgiBA;IAhiBA;EAgiBA;AAAA;;AAhiBA;EAAA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;EAhiBA;IAAA;EAgiBA;AAAA","sourcesContent":["/* Brand fonts. Both bundled by webpack (asset/resource) — see webpack.config.js. */\n@font-face {\n  font-family: 'Nicholas';\n  src: url('./assets/fonts/Nicholas-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Poppins';\n  src: url('./assets/fonts/Poppins-ExtraLight.ttf') format('truetype');\n  font-weight: 200;\n  font-style: normal;\n  font-display: swap;\n}\n/* Real semibold for deliberate emphasis only. Kept under its own family name so\n   the app's existing font-semibold/bold classes keep their current look. */\n@font-face {\n  font-family: 'Poppins Emphasis';\n  src: url('./assets/fonts/Poppins-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n:root {\n  --snail: #5D4E2F;      /* Primary accent, active states */\n  --sand: #EEE9E1;       /* Light backgrounds, cards */\n  --pewter: #4E574E;     /* Secondary elements, borders */\n  --dew: #DAD6CE;        /* Hover states, subtle highlights */\n  --forest: #263328;     /* Dark UI elements, sidebar */\n  --charcoal: #181818;   /* Primary dark background */\n  --stone: #3a3a3a;      /* Dark border color */\n  --fern: #04963a;       /* Success, interactive green */\n  --midnight: #0f0f0f;   /* Deepest dark, dropdowns */\n  --black: #000000;      /* Pure black backgrounds */\n  --error-red: #ef4444;  /* Error, destructive actions */\n  --rust: #9a3412;       /* Warning, attention states */\n\n  /* Brand typography */\n  --font-heading: 'Nicholas', 'Helvetica Neue', Arial, sans-serif;\n  --font-body: 'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif;\n  --font-emphasis: 'Poppins Emphasis', 'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif;\n}\n\n.ls-emphasis {\n  font-family: var(--font-emphasis);\n  font-weight: 600;\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ── Canonical modal surfaces ─────────────────────────────────────────────\n   Single source of truth for every dialog on the platform, so they all share\n   one frame. The card backing + stroke are both charcoal: the backing means\n   the rounded corners can never leak a lighter colour (the old sand-bleed\n   bug), and the charcoal stroke reads as a clean edge distinct from any of the\n   forest/sand/pewter section bands. Edge separation from the scrim comes from a\n   soft, layered shadow rather than a hard border. Header/body/footer bands\n   paint their own backgrounds on top. */\n.ls-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.72);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.ls-modal-card {\n  background-color: var(--charcoal);\n  border: 1px solid var(--charcoal);\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow:\n    0 32px 80px -24px rgba(0, 0, 0, 0.75),\n    0 12px 34px -14px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba(0, 0, 0, 0.4);\n}\n\n/* Header/footer bands lose their own outer rounding since .ls-modal-card clips;\n   this just keeps their top/bottom corners flush inside the frame. */\n.ls-modal-band-top    { border-top-left-radius: 13px; border-top-right-radius: 13px; }\n.ls-modal-band-bottom { border-bottom-left-radius: 13px; border-bottom-right-radius: 13px; }\n\n/* Gentle entrance for modal cards — a whisper of lift, nothing bouncy. */\n@keyframes lsModalIn {\n  from { opacity: 0; transform: translateY(8px) scale(0.985); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n.ls-modal-card-animate { animation: lsModalIn 0.22s cubic-bezier(0.16, 1, 0.3, 1); }\n\n/* Layer-row slider extension (SliderUnderBar) — quick settle as the row expands. */\n@keyframes lsUnderbarIn {\n  from { opacity: 0; transform: translateY(-3px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.ls-underbar { animation: lsUnderbarIn 0.15s ease-out; }\n\n@media (prefers-reduced-motion: reduce) {\n  .ls-modal-card-animate { animation: none; }\n  .ls-underbar { animation: none; }\n}\n\n/* Smooth fade-in animation for waitlist modal */\n@keyframes fadeInSlide {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Cesium specific styles */\nhtml, body, #root {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  font-family: var(--font-body);\n}\n\n/* Headings use the brand display face. */\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-heading);\n}\n\n/* Tailwind utility for opting in explicitly when the element isn't a real heading. */\n.font-heading { font-family: var(--font-heading) !important; }\n.font-body    { font-family: var(--font-body) !important; }\n\n/* Print styles for Report Modal */\n@media print {\n  html, body {\n    background: #ffffff !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n    color-adjust: exact !important;\n    height: auto !important;\n    overflow: visible !important;\n  }\n  /* Hide everything by default */\n  body * { visibility: hidden !important; }\n  /* Show only the report modal content and its children */\n  #report-modal-content, #report-modal-content * {\n    visibility: visible !important;\n  }\n  /* Position the modal content at the top-left and expand for page */\n  #report-modal-content {\n    position: static !important;\n    inset: auto !important;\n    box-shadow: none !important;\n    border: 0 !important;\n    background: #ffffff !important;\n    max-height: none !important;\n    overflow: visible !important;\n    width: auto !important;\n    height: auto !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  /* Prevent awkward page breaks in cards/grids */\n  #report-modal-content .border-2,\n  #report-modal-content .p-4,\n  #report-modal-content .rounded-lg,\n  #report-modal-content .grid,\n  #report-modal-content .h-64 {\n    break-inside: avoid !important;\n    page-break-inside: avoid !important;\n  }\n  #report-modal-content svg { max-width: 100% !important; height: auto !important; }\n  /* Remove global layout constraints */\n  #root { height: auto !important; overflow: visible !important; }\n}\n\n/* When we explicitly request print via the button, relax global overflow too */\nbody.force-print {\n  overflow: visible !important;\n}\n\n/* Ensure Cesium container takes full space */\n#cesiumContainer {\n  width: 100% !important;\n  height: 100% !important;\n  position: relative !important;\n}\n\n/* Ensure Cesium widget takes full space */\n.cesium-widget,\n.cesium-widget canvas {\n  width: 100% !important;\n  height: 100% !important;\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n}\n\n/* Basemap attribution. Cesium's own credit display stays in charge of what is\n   shown (ion and Google logos on screen, per-view copyright behind the \"Data\n   attribution\" link) because the ion and Google terms both require it; this\n   only gives it the house look. Sits under the bottom-left pills (bottom-7). */\n.cesium-viewer-bottom {\n  z-index: 2;\n  padding: 0 0 4px 8px;\n  line-height: 1;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n.cesium-viewer .cesium-widget-credits {\n  font-family: var(--font-body);\n  font-size: 10px;\n  color: #fff;\n  text-shadow: 0 0 2px rgba(0, 0, 0, 0.9), 0 1px 2px rgba(0, 0, 0, 0.7);\n}\n\n.cesium-credit-logoContainer,\n.cesium-credit-textContainer,\n.cesium-credit-expand-link {\n  pointer-events: auto;\n  vertical-align: middle;\n}\n\n.cesium-credit-logoContainer {\n  margin-right: 14px;\n}\n\n.cesium-viewer .cesium-credit-textContainer .cesium-credit-wrapper:first-of-type {\n  padding-left: 0;\n}\n\n.cesium-credit-textContainer .cesium-credit-wrapper {\n  margin-right: 10px;\n}\n\n.cesium-viewer .cesium-credit-delimiter {\n  padding: 0 4px 0 0;\n}\n\n.cesium-credit-logoContainer img,\n.cesium-credit-textContainer img {\n  height: 18px;\n  width: auto;\n  vertical-align: middle !important;\n}\n\n.cesium-viewer .cesium-credit-expand-link {\n  padding-left: 4px;\n  color: rgba(255, 255, 255, 0.85);\n  text-decoration: none;\n}\n\n.cesium-viewer .cesium-credit-expand-link:hover {\n  color: #fff;\n  text-decoration: underline;\n}\n\n/* ion injects an \"Upgrade for commercial use.\" link on Community-plan tokens,\n   which only the dev token is. Hide it and whichever delimiter bounds it. */\n.cesium-credit-wrapper:has(a[href*=\"cesium.com/pricing\"]),\n.cesium-credit-wrapper:has(a[href*=\"cesium.com/pricing\"]) + .cesium-credit-delimiter,\n.cesium-credit-delimiter:has(+ .cesium-credit-wrapper a[href*=\"cesium.com/pricing\"]) {\n  display: none !important;\n}\n\n.cesium-credit-lightbox-overlay {\n  z-index: 200 !important;\n  background-color: rgba(24, 24, 24, 0.6) !important;\n}\n\n.cesium-credit-lightbox {\n  font-family: var(--font-body);\n  background-color: var(--forest) !important;\n  color: var(--sand) !important;\n  border: 1px solid var(--pewter) !important;\n  border-radius: 13px !important;\n}\n\n/* Cesium centres the box by an inline margin-top it measures once, before the\n   copyright list has its final height, so a long Google list drifts low. Pin\n   it to the true centre and let the list scroll instead. */\n.cesium-credit-lightbox.cesium-credit-lightbox-expanded {\n  position: absolute !important;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  margin: 0 !important;\n  width: min(560px, calc(100% - 32px));\n  max-width: none !important;\n  max-height: min(70vh, calc(100% - 32px));\n  display: flex;\n  flex-direction: column;\n}\n\n.cesium-credit-lightbox-title {\n  font-family: var(--font-emphasis);\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.cesium-credit-lightbox > ul {\n  font-size: 12px !important;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.cesium-credit-lightbox > ul > li a,\n.cesium-credit-lightbox > ul > li a:visited {\n  color: var(--sand) !important;\n}\n\n.cesium-credit-lightbox > ul > li a:hover,\n.cesium-credit-lightbox-close:hover {\n  color: var(--dew) !important;\n}\n\n.cesium-credit-lightbox > ul > li img {\n  max-height: 24px;\n  vertical-align: middle;\n}\n\n/* The same logos reproduced on the printed map window (PrintMapOverlay). */\n.print-basemap-logo img {\n  height: 18px;\n  width: auto;\n  vertical-align: middle !important;\n}\n\n.cesium-viewer-toolbar {\n  display: none !important;\n}\n\n.cesium-viewer-animationContainer {\n  display: none !important;\n}\n\n.cesium-viewer-timelineContainer {\n  display: none !important;\n}\n\n.cesium-viewer-fullscreenContainer {\n  display: none !important;\n}\n\n.cesium-viewer-vrContainer {\n  display: none !important;\n}\n\n/* Info Panel Text Wrapping Styles */\n.info-panel-content {\n  word-wrap: break-word !important;\n  overflow-wrap: anywhere !important;\n}\n\n.info-panel-content p,\n.info-panel-content div,\n.info-panel-content span,\n.info-panel-content td,\n.info-panel-content th {\n  word-wrap: break-word !important;\n  overflow-wrap: anywhere !important;\n}\n\n.info-panel-content pre {\n  white-space: pre-wrap !important;\n  word-wrap: break-word !important;\n}\n\n.info-panel-content table {\n  table-layout: fixed !important;\n  width: 100% !important;\n}\n\n/* Dot loader animation */\n.dot-loader {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n.dot-loader .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background-color: var(--dew);\n  opacity: 0.4;\n  animation: dotFlashing 1.1s linear infinite;\n}\n.dot-loader .dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.dot-loader .dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes dotFlashing {\n  0% { opacity: 0.3; transform: translateY(0); }\n  50% { opacity: 1; transform: translateY(-2px); }\n  100% { opacity: 0.3; transform: translateY(0); }\n}\n\n/* Comment markdown content styles */\n.comment-content {\n  line-height: 1.5;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n}\n.comment-content p {\n  margin: 0 0 0.5em 0;\n}\n.comment-content p:last-child {\n  margin-bottom: 0;\n}\n.comment-content strong {\n  font-weight: 600;\n}\n.comment-content em {\n  font-style: italic;\n}\n.comment-content ul,\n.comment-content ol {\n  margin: 0.5em 0;\n  padding-left: 1.5em;\n}\n.comment-content li {\n  margin: 0.25em 0;\n}\n.comment-content code {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 0.1em 0.3em;\n  border-radius: 3px;\n  font-family: monospace;\n  font-size: 0.9em;\n}\n.comment-content a {\n  color: var(--fern, #4ade80);\n  text-decoration: underline;\n}\n.comment-content a:hover {\n  opacity: 0.8;\n}\n\n/* Comment highlight pulse animation */\n@keyframes highlight-pulse {\n  0%, 100% { background-color: transparent; }\n  50% { background-color: rgba(74, 222, 128, 0.2); }\n}\n\n.highlight-pulse {\n  animation: highlight-pulse 0.5s ease-in-out 3;\n}\n\n/* Help tooltip */\n.help-tooltip-trigger .help-tooltip {\n  display: none;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  padding: 12px 14px;\n  background-color: var(--charcoal);\n  border: 1px solid var(--pewter);\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--dew);\n  width: 280px;\n  max-width: 90vw;\n  z-index: 99999;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n}\n\n.help-tooltip-trigger:hover .help-tooltip {\n  display: block;\n}\n\n/* Thin dark scrollbars */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--stone) transparent;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--stone);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--pewter);\n}\n\n/* Demo unlock CTA — a pill whose stroke has a highlight travelling around it.\n   Interior is painted with a padding-box layer, the rotating conic-gradient\n   sits in the border-box layer and shows only through the transparent border.\n   --demo-ring-color (tier color) and --demo-pill-bg (interior, swapped on\n   hover) are set inline by the component. */\n@property --demo-ring-angle {\n  syntax: '<angle>';\n  initial-value: 0deg;\n  inherits: false;\n}\n\n@keyframes demoRingSpin {\n  to {\n    --demo-ring-angle: 360deg;\n  }\n}\n\n.demo-unlock-pill {\n  border: 2px solid transparent;\n  border-radius: 9999px;\n  background:\n    linear-gradient(var(--demo-pill-bg, #EEE9E1), var(--demo-pill-bg, #EEE9E1)) padding-box,\n    conic-gradient(\n      from var(--demo-ring-angle),\n      var(--demo-ring-color, #dc2626) 0deg,\n      #ffffff 28deg,\n      var(--demo-ring-color, #dc2626) 70deg,\n      var(--demo-ring-color, #dc2626) 360deg\n    ) border-box;\n  animation: demoRingSpin 2.8s linear infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .demo-unlock-pill {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
